import "./Layout.css";
import Header from "./Header";
import { ConfigProvider } from "antd";
import { Layout as AntdLayout } from "antd";
import { useSelector } from "react-redux";
import SideNav from "./SideNav";
import antdTheme from "../../theme/AntDTheme";
import { useLocation } from "react-router-dom";
import NotificationsPop from "./NotificationsPop";

export default function Layout({ children }) {
  const location = useLocation();
  const currentUrlPath = location.pathname;
  const isAuthenticated = useSelector((state) => state.oauth.isAuthenticated);
  return (
    <ConfigProvider theme={antdTheme}>
      <AntdLayout style={{ minHeight: "100vh", overflow: "hidden" }}>
        <SideNav />
        <AntdLayout
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Header />
          <NotificationsPop />
          <AntdLayout.Content
            id="main-scrollable-layout"
            style={{
              paddingTop:
                !isAuthenticated || currentUrlPath === "/" ? "0px" : "60px",
              height: "100%",
              overflowY: "auto",
            }}
          >
            {children}
          </AntdLayout.Content>
        </AntdLayout>
      </AntdLayout>
    </ConfigProvider>
  );
}
